import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { channelPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import React from 'react';
import styled from 'styled-components';

const ChannelCount = styled.div`
    ${FONTS.L};
`;

const Channels = styled.div`
    justify-content: ${props => props.count < 5 ? 'flex-start' : 'space-between'};
    columns: 5;
    @media (max-width: 640px) {
        columns: 2;
    }
`;

const Channel = styled.div`
    width: 20%;
    padding: 20px 5px;
    flex-direction: column;
    @media (max-width: 640px) {
        width: 48%;
    }
`;

const ChannelLogo = styled.div`
    width: 90px;
    height: 90px;
    padding: 10px;
    justify-content: center;
    align-content: center;
    margin-bottom: 5px;
`;

const ChannelLogoImage = styled.img`
    max-width: 70px;
    max-height: 70px;
`;

const getChannelsText = getPluralize(channelPluralize);

const ChannelsList = ({ channels = [] }) => {
    const count = channels.length;
    if (count === 0) {
        return null;
    }
    return (
        <React.Fragment>
            <ChannelCount>Пакет включает в себя {count} {getChannelsText(count)}:</ChannelCount>
            <Channels count={channels.length}>
                {
                    channels.map(({ logo, title }, key) => (
                        <Channel key={key}>
                            <ChannelLogo>
                                <ChannelLogoImage src={logo} />
                            </ChannelLogo>
                            <span>{title}</span>
                        </Channel>
                    ))
                }
            </Channels>
        </React.Fragment>
    );
};

export default ChannelsList;
